import * as React from 'react';

import BaseSalesListLayout from './BaseSalesListLayout';
import SaleDetailPopup from '~/apps/pos/admin/containers/sales/SaleDetailPopup';

export default function ({saleId}) {
  return BaseSalesListLayout(
    <SaleDetailPopup saleId={saleId}/>
  );
};
